/**
 * Interceptor to normalize provider data.
 *
 * @param data the axios response
 *
 * @category Query Functions - getProviders
 * @category Interceptor Functions
 */
export const normalizeProvidersResData = (data) => {
    return data;
};
//# sourceMappingURL=output.js.map